import { COMPANY } from "@/lib/site";

const Page = ({ title, testid, children }) => (
  <div data-testid={testid} className="pt-32 pb-24">
    <section className="mx-auto max-w-3xl px-5 lg:px-10">
      <p className="text-gold text-xs tracking-[0.4em] uppercase">Informations légales</p>
      <h1 className="mt-4 font-serif text-4xl sm:text-5xl text-white">{title}</h1>
      <div className="gold-hairline my-10" />
      <div className="space-y-8 text-white/70 leading-relaxed text-[15px]">{children}</div>
    </section>
  </div>
);

const Block = ({ h, children }) => (
  <div>
    <h2 className="font-serif text-xl text-white mb-3">{h}</h2>
    <div className="space-y-2">{children}</div>
  </div>
);

const Row = ({ k, v }) => (
  <p><span className="text-white/45">{k} : </span><span className="text-white/85">{v}</span></p>
);

export function MentionsLegales() {
  return (
    <Page title="Mentions Légales" testid="mentions-page">
      <Block h="Éditeur du site">
        <Row k="Raison sociale" v={COMPANY.name} />
        <Row k="Forme juridique" v={COMPANY.legalForm} />
        <Row k="Capital social" v={COMPANY.capital} />
        <Row k="RCS" v={COMPANY.rcs} />
        <Row k="EUID" v={COMPANY.euid} />
        <Row k="Siège social" v={COMPANY.address} />
        <Row k="Président" v={`${COMPANY.president} (né le ${COMPANY.presidentBirth})`} />
        <Row k="Activité" v={COMPANY.activity} />
      </Block>
      <Block h="Hébergeur">
        <p>{COMPANY.host}</p>
      </Block>
      <Block h="Propriété intellectuelle">
        <p>
          L'ensemble des contenus (textes, photographies, logos, éléments graphiques) présents sur ce site sont la propriété
          exclusive de {COMPANY.name} ou de ses partenaires. Toute reproduction, représentation ou diffusion, totale ou
          partielle, sans autorisation écrite préalable est interdite et constitue une contrefaçon.
        </p>
      </Block>
      <Block h="Données personnelles">
        <p>
          Les informations collectées lors d'une réservation sont utilisées uniquement pour l'exécution de la prestation.
          Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données en nous
          contactant à l'adresse du siège social.
        </p>
      </Block>
    </Page>
  );
}

export function CGV() {
  return (
    <Page title="Conditions Générales de Vente" testid="cgv-page">
      <Block h="Article 1 — Objet">
        <p>
          Les présentes CGV régissent les prestations de transport de personnes et de mise à disposition de véhicules avec
          chauffeur proposées par {COMPANY.name}, réservées via le présent site.
        </p>
      </Block>
      <Block h="Article 2 — Prix">
        <p>
          Tous les prix sont indiqués en euros toutes taxes comprises (TTC). Le prix de la course est calculé et affiché avant
          paiement en fonction du trajet, du véhicule, de la durée et des options sélectionnées. Le montant validé lors du
          paiement est ferme et définitif.
        </p>
      </Block>
      <Block h="Article 3 — Modalités de paiement">
        <p>
          Le paiement s'effectue en ligne, au moment de la réservation, par carte bancaire via notre prestataire sécurisé
          Stripe. Aucune coordonnée bancaire n'est stockée sur nos serveurs. La réservation n'est confirmée qu'après validation
          effective du paiement.
        </p>
      </Block>
      <Block h="Article 4 — Rétractation & annulation">
        <p>
          L'annulation est gratuite jusqu'à 24 heures avant l'heure prévue de la course : le client est alors intégralement
          remboursé. Toute annulation intervenant moins de 24 heures avant la course pourra donner lieu à une retenue pouvant
          aller jusqu'à 100 % du montant. S'agissant d'une prestation de transport à date déterminée, le droit de rétractation
          de 14 jours ne s'applique pas (article L221-28 du Code de la consommation).
        </p>
      </Block>
      <Block h="Article 5 — Responsabilité">
        <p>
          {COMPANY.name} est couverte par une assurance de responsabilité civile professionnelle et transport de personnes.
          La société s'engage à mettre en œuvre tous les moyens pour assurer la ponctualité, sans que sa responsabilité puisse
          être engagée en cas de retard résultant de circonstances indépendantes de sa volonté.
        </p>
      </Block>
      <Block h="Article 6 — Force majeure">
        <p>
          En cas de force majeure (conditions météorologiques extrêmes, grèves, blocages routiers, événements imprévisibles),
          la responsabilité de {COMPANY.name} ne saurait être engagée. Une solution de remplacement ou un remboursement sera
          proposé au client.
        </p>
      </Block>
      <Block h="Article 7 — Droit applicable">
        <p>Les présentes CGV sont soumises au droit français. Tout litige relèvera des tribunaux compétents du ressort du siège social.</p>
      </Block>
    </Page>
  );
}

export function CGU() {
  return (
    <Page title="Conditions Générales d'Utilisation" testid="cgu-page">
      <Block h="Article 1 — Acceptation">
        <p>
          L'accès et l'utilisation du site impliquent l'acceptation pleine et entière des présentes conditions d'utilisation
          par tout visiteur.
        </p>
      </Block>
      <Block h="Article 2 — Utilisation du site">
        <p>
          Le site a pour objet la présentation des services de {COMPANY.name} et la réservation en ligne de prestations de
          transport. L'utilisateur s'engage à fournir des informations exactes lors de sa réservation et à utiliser le site de
          manière loyale.
        </p>
      </Block>
      <Block h="Article 3 — Propriété intellectuelle">
        <p>
          L'ensemble des contenus du site (photos, textes, marques, logos) est protégé par le droit de la propriété
          intellectuelle et demeure la propriété de {COMPANY.name}. Toute reproduction non autorisée est interdite.
        </p>
      </Block>
      <Block h="Article 4 — Limitation de responsabilité">
        <p>
          {COMPANY.name} s'efforce d'assurer l'exactitude des informations diffusées mais ne saurait être tenue responsable des
          erreurs, d'une indisponibilité temporaire du site ou de tout dommage résultant de son utilisation.
        </p>
      </Block>
      <Block h="Article 5 — Liens & prestataires">
        <p>
          Le site fait appel à des prestataires tiers (notamment Stripe pour le paiement). L'utilisation de ces services est
          soumise à leurs propres conditions.
        </p>
      </Block>
    </Page>
  );
}
